import React from "react";

export function Empty({ msg }) {
  return <div className="grid-card p-10 text-center text-[var(--text-2)] text-sm">{msg}</div>;
}
